// extracted by mini-css-extract-plugin
module.exports = {"mapBox":"Map_mapBox__sG6l5"};